import React, { Component } from 'react';
import '../assets/teachers.css';
import logo from '../assets/images/logo_avenuepm.png';
import {connect} from "react-redux";
import icon_twitter from "../assets/images/Twitter_Social_Icon.png";
import icon_fackbook from "../assets/images/Facebook_logo.png";

const Footer = class FooterComponent extends Component {

    render() {
        return (
            <footer>
                <div className="row" style={{marginBottom:25}}>
                    <div className="col-sm-6" style={{textAlign:'right', paddingRight:80}}>
                        <b>Follow us: </b>
                    </div>
                    <div className="col-sm-6" style={{textAlign:'left'}}>
                        <div style={{marginTop:-1, marginLeft: -60}}>
                            <a href={"https://twitter.com/AvenuePM"} style={{ textDecoration: 'none' }} target="_blank">
                                <img src={icon_twitter} style={{width:28, height:28}} alt="" border="0" /> Twitter
                            </a>
                        </div>
                        <div style={{marginLeft:55, marginTop:-28}}>
                            <a href={"https://www.facebook.com/profile.php?id=100009224578527&lst=100006500830477%3A100009224578527%3A1587693428&sk=timeline"} style={{ textDecoration: 'none' }} target="_blank">
                                <img src={icon_fackbook} style={{width:28, height:28}} alt="" border="0" /> Facebook
                            </a>
                        </div>
                    </div>
                </div>
                <div className="container">

                    <div className="col-lg-12">
                        <p>&copy;
                            {new Date().getFullYear() > 2010 && new Date().getFullYear()}{' '}
                              Designed and developed by researchers at the University of Minnesota and Penn State
                            University.
                        </p>
                    </div>
                </div>
            </footer>
        )
    }
};

export default Footer



// WEBPACK FOOTER //
// ./src/Shared/Footer.js